import { default as casinosbhLxYctqdMeta } from "/app/pages/casino.vue?macro=true";
import { default as cheat_45panel7xyflXdVxhMeta } from "/app/pages/cheat-panel.vue?macro=true";
import { default as email_45inboximPsoLDB0NMeta } from "/app/pages/email-inbox.vue?macro=true";
import { default as event_45simulationZxiqIY1wtKMeta } from "/app/pages/event-simulation.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as lotteryiyHkAtXLHjMeta } from "/app/pages/lottery.vue?macro=true";
import { default as _91slug_93bjLXGc3guEMeta } from "/app/pages/play/[slug].vue?macro=true";
import { default as sms_45inboxnSCTEadSFRMeta } from "/app/pages/sms-inbox.vue?macro=true";
import { default as sportsbookAKQjrWUAgAMeta } from "/app/pages/sportsbook.vue?macro=true";
import { default as user_45consentsmg9LhDi87XMeta } from "/app/pages/user-consents.vue?macro=true";
import { default as walletfANoq5LO2uMeta } from "/app/pages/wallet.vue?macro=true";
export default [
  {
    name: "casino",
    path: "/casino",
    component: () => import("/app/pages/casino.vue")
  },
  {
    name: "cheat-panel",
    path: "/cheat-panel",
    component: () => import("/app/pages/cheat-panel.vue")
  },
  {
    name: "email-inbox",
    path: "/email-inbox",
    component: () => import("/app/pages/email-inbox.vue")
  },
  {
    name: "event-simulation",
    path: "/event-simulation",
    component: () => import("/app/pages/event-simulation.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "lottery",
    path: "/lottery",
    component: () => import("/app/pages/lottery.vue")
  },
  {
    name: "play-slug",
    path: "/play/:slug()",
    component: () => import("/app/pages/play/[slug].vue")
  },
  {
    name: "sms-inbox",
    path: "/sms-inbox",
    component: () => import("/app/pages/sms-inbox.vue")
  },
  {
    name: "sportsbook",
    path: "/sportsbook",
    component: () => import("/app/pages/sportsbook.vue")
  },
  {
    name: "user-consents",
    path: "/user-consents",
    component: () => import("/app/pages/user-consents.vue")
  },
  {
    name: "wallet",
    path: "/wallet",
    component: () => import("/app/pages/wallet.vue")
  }
]